"use client";

import React from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";

export interface PortfolioActionButtonProps {
  /** 自定义类名 */
  className?: string;
  /** 图标自定义类名 */
  iconClassName?: string;
  /** 标题文本 */
  title: string;
  /** 自定义样式 */
  style?: React.CSSProperties;
  /** 点击事件 */
  onClick?: () => void;
}

/**
 * Portfolio Action Button 组件
 * 用于显示投资组合操作按钮，包含图标、标题和箭头
 */
export const PortfolioActionButton: React.FC<PortfolioActionButtonProps> = ({
  className,
  iconClassName,
  title,
  style,
  onClick,
}) => {
  return (
    <div
      data-openreplay-label="AiPortfolioCard · PortfolioActionButton · div"
      className={cn(
        "bg-background_white_overlay5 cursor-pointer",
        "flex items-center justify-between gap-3",
        "pl-3 pr-2 md:px-4 py-3.5 rounded-xl overflow-clip",
        className,
      )}
      style={style}
      onClick={onClick}
    >
      {/* 左侧：图标和标题 */}
      <div className="flex items-center gap-2 md:gap-3">
        <span
          className={cn(
            "shrink-0 w-10 h-10 rounded-full flex items-center justify-center [box-shadow:0_3px_4px_0_rgba(255,255,255,0.05)_inset] bg-no-repeat bg-center",
            iconClassName,
          )}
        />
        <p className="body_bold_m text-content_primary">{title}</p>
      </div>

      {/* 右侧：箭头图标（默认隐藏，md 显示） */}
      <p className="hidden md:block shrink-0">
        <Icon
          name="right-arrow-alt"
          size={20}
          className="text-content_primary"
        />
      </p>
    </div>
  );
};
